import React, { useContext } from 'react';
import classNames from 'classnames';
import { ThemeContext } from '../App/App';
import style from './LoadingSpinner.module.scss';

interface Props {
	size?: number;
	absoluteSize?: number;
	className?: string;
}

export default ({ size, absoluteSize, className }: Props) => {
	const { styles: themeStyle } = useContext(ThemeContext);
	const dimension = absoluteSize ? `${absoluteSize}px` : size ? `${size * 36}px` : undefined;
	const getSizeStyle = () => (dimension ? { width: dimension, height: dimension } : undefined);

	return (
		<div
			style={getSizeStyle()}
			className={classNames(style.loadingSpinner, themeStyle.themeSpinner, className)}
		>
			<div style={getSizeStyle()} />
			<div style={getSizeStyle()} />
			<div style={getSizeStyle()} />
			<div style={getSizeStyle()} />
		</div>
	);
};
